export const ROUTES = {
  LOGIN: '/login',
  ROOT: '/',
} as const;

export const AUTH_ROUTES = {
  VERIFY_USER: '/verify-user',
  OAUTH: '/oauth',
  OAUTH_CALLBACK: '/oauth-callback',
  SAML: '/saml',
  SAML_PROVIDERS: '/saml/providers',
} as const;

/**
 * Routes deliberately reached through the system browser tab instead of the
 * UXP WebView (currently just the OAuth callback Cognito redirects to after
 * Google/Apple SSO). Two surfaces consume this:
 *
 * - `BrowserGate` — must NOT block these, or the callback page never mounts,
 *   the fetch to `/pluginAuth/state` never fires, and the plugin polls forever.
 * - `AppShell` — must skip its panel chrome (`TitleBar` + the `flex-1
 *   overflow-auto` wrapper) on these routes so the browser tab renders the
 *   full-screen designed card without a UXP-only title bar and without the
 *   `scrollbar-gutter: stable` gutter from `globals.css` reserving a
 *   permanent scrollbar track.
 *
 * Keep this as a single source of truth — drifting copies in each consumer
 * is the bug we're avoiding.
 */
export const BROWSER_TAB_ROUTES = new Set<string>([AUTH_ROUTES.OAUTH_CALLBACK]);
